var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFanyi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.588v.736h.48c.192.512.48.944.872 1.296-.528.216-1.16.392-1.888.536l.392.696c.88-.184 1.624-.424 2.232-.72.576.32 1.296.528 2.176.632l.296-.728a6.853 6.853 0 01-1.688-.368c.528-.392.88-.856 1.064-1.392v-.688H7zm1.296.736h1.768c-.216.352-.544.656-.976.928a2.44 2.44 0 01-.792-.928zM7.232 8.22v.752h1.416v.688h-1.76v.784h1.76v1.32h.832v-1.32h1.912V9.66H9.48v-.688H11V8.22H9.48v-.632h-.832v.632H7.232zM5.224 4.38l-.592.576c.568.416 1.008.808 1.312 1.176l.576-.584c-.36-.384-.792-.776-1.296-1.168zm-1.12 2.312v.8h1.064V10.3c0 .184-.08.336-.224.464l.32.752a12.375 12.375 0 001.528-1.384l-.224-.888c-.208.224-.4.44-.592.64V6.692H4.104z",
    fill: "#3F465C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 11,
    height: 11,
    rx: 0.5,
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_fanyi.7f01bd5a.svg";
export { SvgTongyongFanyi as ReactComponent };